"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOutsideEndDays = void 0;
var date_fns_1 = require("date-fns");
function getOutsideEndDays(month, options) {
    var days = [];
    var lastDayOfWeek = date_fns_1.endOfWeek(month, options);
    var endDiff = date_fns_1.differenceInCalendarDays(lastDayOfWeek, month);
    for (var i = 1; i <= endDiff; i++) {
        var dayDate = date_fns_1.addDays(month, i);
        days.push(dayDate);
    }
    return days;
}
exports.getOutsideEndDays = getOutsideEndDays;
//# sourceMappingURL=getOutsideEndDays.js.map